import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { S25Util } from "../../util/s25-util";
import { ViewerMessageService } from "../../services/viewer.message.service";
import { UserprefService } from "../../services/userpref.service";
import { S25PipesModule } from "../../pipes/s25.pipes.module";
import { S25IconComponent } from "../s25-icon/s25.icon.component";

@Component({
    selector: "s25-ng-viewer-message",
    template: `
        @if (visible) {
            <div class="s25-viewer-message">
                <div class="cn-alert cn-alert--info c-margin-bottom--single" role="alert">
                    <s25-ng-icon [type]="'info'"></s25-ng-icon>
                    <div class="cn-alert__label">
                        <span [innerHTML]="message | safeHTML"></span>
                    </div>
                    @if (canDismiss) {
                        <button (click)="dismiss()" aria-label="Dismiss alert" class="cn-alert__close" type="button">
                            <s25-ng-icon [type]="'close'"></s25-ng-icon>
                        </button>
                    }
                </div>
            </div>
        }
    `,
    styles: "",
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25IconComponent, S25PipesModule],
})
export class S25ViewerMessageComponent implements OnInit {
    constructor(private cd: ChangeDetectorRef) {}

    storageKey = "viewer_message_visible";
    visible = false;
    canDismiss = false;
    message = "";

    async ngOnInit() {
        const resp = await S25Util.all({
            message: ViewerMessageService.getViewerMessage(),
            loggedIn: UserprefService.getLoggedIn(),
        });
        if (resp.message && !resp.loggedIn) {
            this.canDismiss = true;
            this.message = resp.message;
            let isVisibleInSession = S25Util.localStorageGet(this.storageKey);
            if (S25Util.isUndefined(isVisibleInSession)) {
                //if session var not set, default to showing it
                this.visible = true;
            } else {
                //otherwise use the session value
                this.visible = S25Util.toBool(isVisibleInSession);
            }
        } else {
            //if no message, do not show anything
            this.visible = false;
        }

        S25Util.localStorageSet(this.storageKey, "" + this.visible);
        this.cd.detectChanges();
    }

    dismiss() {
        this.visible = false;
        S25Util.localStorageSet(this.storageKey, "" + this.visible);
        this.cd.detectChanges();
    }
}
